import type { Redirect } from './provider';

/**
 * Send the browser to the provider's hosted checkout page.
 *
 *  - `kind:'url'`  → simple location redirect (Stripe, and some NiHaoPay vendors).
 *  - `kind:'form'` → build + auto-submit a hidden POST form. SecurePay returns
 *    this shape for some wallets, so the form path is MANDATORY — a plain
 *    redirect would drop the POST body.
 *
 * Client-only (touches `document`/`window`).
 */
export function redirectToCheckout(redirect: Redirect): void {
  if (redirect.kind === 'url') {
    window.location.assign(redirect.url);
    return;
  }

  // NiHaoPay returns a full HTML page whose embedded script auto-submits a
  // signed form to the wallet gateway. Replace the document with it and let
  // its own script run the redirect.
  if (redirect.kind === 'html') {
    document.open();
    document.write(redirect.html);
    document.close();
    return;
  }

  const form = document.createElement('form');
  form.method = redirect.method || 'POST';
  form.action = redirect.actionUrl;
  form.style.display = 'none';

  for (const [key, value] of Object.entries(redirect.params)) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = value;
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
}
